export default __webpack_public_path__ + "static/eating-e0af8e47596098b84cce97a5f3262d0e.svg";